module.exports = __webpack_public_path__ + "img/bahana.231124cd.png";